import ReadmeViewer from './ReadmeViewer';

const ReadMeModal = ({ task, onClose }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <div className="readme-heading readme-modal-backdrop" onClick={handleBackdropClick}>
      <div className="readme-modal-content" style={{ width: '80%', height: '80vh' ,}}>
        <div className="readme-modal-header">
          <h2 className="readme-modal-title">Read Me</h2>
          <button
            onClick={onClose}
            className="readme-modal-close-btn"
            aria-label="Close"
            title="Close"
          >
            &times;
          </button>
        </div>
        <hr className="readme-modal-divider" />
        <ReadmeViewer task={task} />
      </div>
    </div>
  );
};

export default ReadMeModal;